(function () {
    'use strict';

    angular.module("imApp").factory("colorGrpMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1206,
                    parameters: parms || {}
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 1207,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
